/* globals LOCALE */
import smoothscroll from 'smoothscroll-polyfill';
import Headroom from 'headroom.js'
import Choices from 'choices.js'
import Inputmask from 'inputmask'
import smoothScroll from 'smoothscroll'


//
Array.prototype.forEach.call(document.querySelectorAll('[data-to-form]'),
el => el.addEventListener('click', e  =>  {
  e.preventDefault()
  smoothScroll(document.querySelector('[data-container-form]'))
})
);

//
smoothscroll.polyfill();


//
if(document.querySelector('[data-header]')) {
  const headroom = new Headroom(document.querySelector('[data-header]'),{
    offset : 120
  });

  headroom.init();
}

//
Array.prototype.forEach.call(document.querySelectorAll('[data-up]'),
el => el.addEventListener('click', e  =>  {
  e.preventDefault()
  window.scroll({ top: 0, left: 0, behavior: 'smooth' })
})
);


//
var select = document.querySelector('.wpcf7-select');

if (select) {

  select.options[0].value = '';
  select.options[0].setAttribute('placeholder', '');

  const choices = new Choices('.wpcf7-select', {
    searchEnabled: false,
    searchChoices: false,
    placeholder: true
  });
}


//
if (document.querySelector('input[type="file"]')) {
  document.querySelector('input[type="file"]').addEventListener('change', function() {
    this.closest('form').querySelector('[data-file-text]').textContent = this.files[0].name
  })
}

//
Inputmask({ mask: "+9{*}" }).mask(document.querySelectorAll("input[type='tel']"));


//
document.addEventListener('click', function (e) {
  const tab = e.target.closest('[data-toggle-vacancy-collapse]')
  if (!tab) return

  const vacancy = e.target.closest('.vacancy-item')
  vacancy.classList.toggle('active')

  const panel = tab.nextElementSibling
  panel.style.maxHeight = panel.style.maxHeight ? null : panel.scrollHeight + 'px'
})



// WEBPACK FOOTER //
// ./src/app.js